import React from "react";
import { useTransition, config, animated } from "@react-spring/web";
import { Container } from "./styled-components";

export interface AnimatedContainerProps {
  isVisible: boolean;
}

const AnimatedContainer = animated(Container);

const AnimatedSelectionsContainer: React.FC<AnimatedContainerProps> = ({
  isVisible,
  children
}) => {
  const transition = useTransition(isVisible, {
    config: isVisible ? { ...config.stiff } : { duration: 300 },
    from: { opacity: 0, transform: `translate3d(0px, -13px, 0px)` },
    enter: { opacity: 1, transform: `translate3d(0px, 0px, 0px)` },
    leave: { opacity: 0, transform: `translate3d(0px, -13px, 0px)` }
  });

  return (
    <>
      {transition(
        (styles, isOpen) =>
          isOpen && (
            <AnimatedContainer
              style={styles}
              data-qa-label="bet-slip-selection-container"
            >
              {children}
            </AnimatedContainer>
          )
      )}
    </>
  );
};

export default AnimatedSelectionsContainer;
